import { BookService } from '@DavisDigital/davisdigitalfrontend.module';

class ConfirmDeleteLicenseModalController {
    
    private close:Function; //injected from modal-service
    private closeCallback:Function;
    
    public licenses:any;
    public username:string;
	
	// @ngInject
	constructor(
		public $timeout : ng.ITimeoutService,
		public ModalService,
		private bookService: BookService
	){}
	
	public onConfirmDelete = () => {
	    this.closeModal(true);
	}
	
    private closeModal = (confirmDelete = false) =>{
		if(this.closeCallback != null){
			this.closeCallback()(confirmDelete);
		}
		
		this.close?.();
    }
    
    public isSampleBook = (bookCode: string) => this.bookService.isSampleBook(bookCode);
    
}

class ConfirmDeleteLicenseModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    licenses: "<",
	    username: "<",
	    close:'=?',
		closeCallback:'&',
	};

	public controller = ConfirmDeleteLicenseModalController;
	public controllerAs = 'confirmDeleteLicenseModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/confirm-delete-license-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ConfirmDeleteLicenseModal };
